import { useCallback } from 'react';
import throttle from 'lodash/throttle';
const defaultOptions = {
  leading: false,
  trailing: true
};

// eslint-disable-next-line default-param-last
export const useThrottle = function (fn) {
  let wait = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 300;
  let options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : defaultOptions;
  let dependencies = arguments.length > 3 ? arguments[3] : undefined;
  const throttled = throttle(fn, wait, options);
  return useCallback(throttled, dependencies);
};